export function _GET_ONE_BY_KEY(array: any[], key: string, value: string) {
	if (!key) {
		return null;
	}
	const result = array.filter(function (o) {
		return o && o[key]?.toLowerCase() == value.toLowerCase();
	});
	return result ? result[0] : null;
}
